import styled from 'styled-components';
import { ReactComponent as EarlierIcon } from '../../icons/earlier.svg';
import { ReactComponent as LaterIcon } from '../../icons/later.svg';
import { BodyLSemibold } from '../TypographyStyles';
import { colors } from '../../utils/colors'
import { fontFamily, purpleColors, slateColors } from '../ContentPages/AppLandingPage/styles';

const BaseButton = styled.button`
  font-family: ${fontFamily};
  display: inline-flex;
  width: auto; /* Ensure the button width adapts to its content */
  padding: 0.625rem 1rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.75rem;
  border: 2px solid ${slateColors[200]};
  background: ${slateColors[50]};
  cursor: pointer;
  color: ${slateColors[700]};
  transition: all 0.2s;
  -webkit-tap-highlight-color: transparent;
  
  &:hover {
    background: ${slateColors[100]};
    border-color: ${purpleColors[300]};
    color: ${slateColors[900]};
  }

  &:active {
    background: ${slateColors[200]};
    border-color: ${purpleColors[400]};
  }

  &:focus {
    outline: none;
    border-color: ${purpleColors[500]};
    box-shadow: 0 0 0 3px ${purpleColors[100]};
  }
  
  & > svg {
    width: 1rem;
    height: 1rem;
    fill: currentColor;
    transition: fill 0.2s;
  }
`;

type Props = {
    onClick: () => void;
} 

export const EarlierButton: React.FC<Props> = ({ onClick }) => {
    return (
        <BaseButton onClick={onClick}>
            <EarlierIcon />
            <BodyLSemibold>Earlier</BodyLSemibold>
        </BaseButton>
    );
    }

export const LaterButton: React.FC<Props> = ({ onClick }) => {
    return (
        <BaseButton onClick={onClick}>
            <LaterIcon />
            <BodyLSemibold>Later</BodyLSemibold>
        </BaseButton>
    );
    }